"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ORDER_TRAVEL = void 0;
exports.ORDER_TRAVEL = {
    INVALID_CARD: {
        usecase: "ORDER_TRAVEL",
        type: "INVALID_CARD",
        messageLangMap: {
            "PT-BR": "Cartão de crédito inválido.",
            "EN-US": "Invalid credit card.",
        },
    },
    INVALID_PAYMENT_METHODS: {
        usecase: "ORDER_TRAVEL",
        type: "INVALID_PAYMENT_METHODS",
        messageLangMap: {
            "PT-BR": "Método de pagamento inválido.",
            "EN-US": "Invalid payment method.",
        },
    },
    INVALID_TRAVEL_ITINERARY: {
        usecase: "ORDER_TRAVEL",
        type: "INVALID_TRAVEL_ITINERARY",
        messageLangMap: {
            "PT-BR": "Itinerário inválido.",
            "EN-US": "Invalid itinerary.",
        },
    },
    NOT_CONFIGURED_SUPPLIERS: {
        usecase: "ORDER_TRAVEL",
        type: "NOT_CONFIGURED_SUPPLIERS",
        messageLangMap: {
            "PT-BR": "Fornecedores não configurados.",
            "EN-US": "Suppliers not configured.",
        },
    },
    PENDING_DOCUMENTS: {
        usecase: "ORDER_TRAVEL",
        type: "PENDING_DOCUMENTS",
        messageLangMap: {
            "PT-BR": "Documentos pendentes.",
            "EN-US": "Pending documents.",
        },
    },
    PLANE_LIMIT_EXCEEDED: {
        usecase: "ORDER_TRAVEL",
        type: "PLANE_LIMIT_EXCEEDED",
        messageLangMap: {
            "PT-BR": "Limite aéreo excedido.",
            "EN-US": "Air limit exceeded.",
        },
    },
    UNPROCESSABLE_OFFER: {
        usecase: "ORDER_TRAVEL",
        type: "UNPROCESSABLE_OFFER",
        messageLangMap: {
            "PT-BR": "Não é possível processar as ofertas.",
            "EN-US": "Unable to process offers.",
        },
    },
    INVALID_CREDITS: {
        usecase: "ORDER_TRAVEL",
        type: "INVALID_CREDITS",
        messageLangMap: {
            "PT-BR": "O pedido tem um ou mais créditos inválidos.",
            "EN-US": "The order has one or more invalid credits.",
        },
    },
};
